// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "3239159",
    "hash": "3239159",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "3239159",
    "semverString": null
};
/* tslint:enable */
